var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Skills Development"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0002 16.04C13.2484 16.04 14.2602 15.0282 14.2602 13.78C14.2602 12.5319 13.2484 11.52 12.0002 11.52C10.7521 11.52 9.74023 12.5319 9.74023 13.78C9.74023 15.0282 10.7521 16.04 12.0002 16.04Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0003 7.11977C12.7901 7.11977 13.4303 6.47953 13.4303 5.68977C13.4303 4.9 12.7901 4.25977 12.0003 4.25977C11.2105 4.25977 10.5703 4.9 10.5703 5.68977C10.5703 6.47953 11.2105 7.11977 12.0003 7.11977Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.29004 19.7398C8.29004 17.6898 9.95004 16.0298 12 16.0298C14.05 16.0298 15.71 17.6898 15.71 19.7398",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 9.19012V7.12012",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.27961 9.48988C7.06938 9.48988 7.70961 8.84965 7.70961 8.05988C7.70961 7.27012 7.06938 6.62988 6.27961 6.62988C5.48984 6.62988 4.84961 7.27012 4.84961 8.05988C4.84961 8.84965 5.48984 9.48988 6.27961 9.48988Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.76004 10.5298L7.29004 9.06982",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.91047 15.2101C4.70024 15.2101 5.34047 14.5699 5.34047 13.7801C5.34047 12.9903 4.70024 12.3501 3.91047 12.3501C3.1207 12.3501 2.48047 12.9903 2.48047 13.7801C2.48047 14.5699 3.1207 15.2101 3.91047 15.2101Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.40984 13.7798H5.33984",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.72 9.48988C18.5098 9.48988 19.15 8.84965 19.15 8.05988C19.15 7.27012 18.5098 6.62988 17.72 6.62988C16.9303 6.62988 16.29 7.27012 16.29 8.05988C16.29 8.84965 16.9303 9.48988 17.72 9.48988Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.2402 10.5298L16.7102 9.06982",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.0902 15.2101C20.8799 15.2101 21.5202 14.5699 21.5202 13.7801C21.5202 12.9903 20.8799 12.3501 20.0902 12.3501C19.3004 12.3501 18.6602 12.9903 18.6602 13.7801C18.6602 14.5699 19.3004 15.2101 20.0902 15.2101Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M16.5898 13.7798H18.6598",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsDevelopment);
export default __webpack_public_path__ + "static/media/Skills Development.7c10865c395843be59fb836535a06a2e.svg";
export { ForwardRef as ReactComponent };